module.exports = __webpack_public_path__ + "static/media/ic_Error-Unavailable.ad61dcc6.svg";